<template>
	<c-modal @close="close" :title="'Tarief bewerken'">

		<div class="text-wrap ">
			<p class="margin-t-32">{{ product.name }}</p>

            <c-form ref="form" @valid="submit" class="margin-t-40">


                <template v-for="item, index in monthlypayment" :key="item">

                        <h6 class="c-text-icon margin-t-24 margin-b-16 c-form-duplicate">
                            Maandbedrag
                            <svg @click="deleteItem(item)" class="color-gray-600 margin-l-8" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
                        </h6>

                        <c-input
                            :label="'Omschrijving'"
                            :horizontal="true"
                            :required="false"
                            v-model="monthlypayment[index].description"
                            :name="monthlypayment[index].description"/>	

                        <c-input
                            :label="'Prijs'"
                            :horizontal="true"
                            :required="false"
                            v-model="monthlypayment[index].price"
                            type="text"
                            :name="monthlypayment[index].price"/>

                </template>


                <a @click="addItem" class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
					<svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
					<span>Nog een artikel toevoegen</span>
				</a>

                <div class="row collapse align-right">
                    <div class="columns shrink">
                        <c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Opslaan</c-button>
                    </div>
                </div>
                
            </c-form>

		</div>
	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import Form from '@mixins/Form';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal
	},
    data() {
        return {
            product: {},
            price: '',
            itemCount: 1,
            monthlypayment: [
                {
                    description: '',
                    price: ''
                }
            ]
        }
    },
	props: {
        payments: {
            required: false
        },
        client_id: {
            required: true
        },
	},
	methods: {
		close() {
			this.$emit('close');
		},
        load() {
			this.$xhr.get("/api/products/" + this.product_id)
				.then( ({result}) => {
					this.product = result;
                    this.price = result.price.price
				})
		},
        addItem() {
            this.monthlypayment.push({ description: '', price: '' });
		},
		deleteItem(item) {
            let index = this.monthlypayment.findIndex( (product) => product.description == item.description);
			this.monthlypayment.splice(index, 1);
		},
        submit(){
            this.$xhr.post("/api/clients/" + this.client_id + "/monthly-payment", {monthlypayment: this.monthlypayment})
				.then( ({}) => {
                    this.close()
                    this.$store.dispatch('toast/success', {title: 'Vaste bedragen aanpassen', text: 'De vaste bedragen  zijn aangepast'});
                    this.$emit('reload');
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                        this.$store.dispatch('toast/alert', {title: 'Vaste bedragen aanpassen', text: 'Er is helaas iets fout gegaan bij het wijzigen van de vaste bedragen '});
                    }
                });
        }
	},
    mounted(){
        if(this.payments.length > 0) {
            this.monthlypayment = this.payments
            this.payments.forEach(element => {
                element.price = element.price.replace('.', ',')
            });
        }
    }
}
</script>